import React, { useState, useEffect, useRef }from 'react';
import { Table, Form, Row, Col, Button } from 'react-bootstrap';
import { IoAdd } from 'react-icons/io5';
import { firestore } from '../../firebase';
import { Link } from 'react-router-dom'

export default function SellersTable() {
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [sellers, setSellers] = useState([]);
    const [query, setQuery] = useState(firestore.collection('vendedores').orderBy('nombre').limit(20));
    const limit = useRef(20);
    const sellersLength = useRef(0);

    function getSellers() {
        setLoading(true);
        query.onSnapshot(querySnapshot => {
            const items = [];
            querySnapshot.forEach(doc => {
                const data = doc.data();
                items.push({
                    id: doc.id,
                    codigo: data.codigo,
                    nombre: data.nombre,
                    notas: data.notas
                });
            })
            sellersLength.current = items.length;
            setSellers(items);
            setLoading(false);
        })
    }

    function createQuery(e) {
        e.preventDefault();
        let newQuery = firestore.collection('vendedores');

        if (search) {
            const searchArray = search.toLowerCase().split(' ')
            newQuery = newQuery.where('keywords', 'array-contains-any', searchArray)
        }

        setQuery(newQuery.orderBy('nombre').limit(limit.current));
    }

    function handleScroll(e) {
        const body = document.body;
        const html = document.documentElement;
        const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        const windowBottom = window.innerHeight + window.pageYOffset;
        if (Math.ceil(windowBottom) >= docHeight && sellersLength.current === limit.current) {
            limit.current = limit.current+20;
            createQuery(e);
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        getSellers();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query])

    return (
        <>
            <Form onSubmit={createQuery}>
                <Row className="m-2">
                    <Col className="my-1" xs={12} sm={8} md={9}>
                        <Form.Group controlId="searchBar">
                            <Form.Control 
                            type="text" 
                            placeholder="Buscar por nombre, codigo, notas..."
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col className="my-1" xs={12} sm={4} md={3}>
                        <Button type="submit">Buscar</Button>
                        <Button className="mx-1 py-0 px-1" href="/sellers/create" style={{fontSize: "1.55rem"}}>
                            <IoAdd/>
                        </Button>
                    </Col>
                </Row>
            </Form>
            <Table responsive striped bordered className='m-auto'>
                <thead>
                    <tr>
                        <th>Codigo</th>
                        <th>Nombre</th>
                        <th>Notas</th>
                    </tr>
                </thead>
                <tbody>
                    {sellers && 
                    sellers.map(seller => {
                        return (
                            <tr key={seller.id}>
                                <td>
                                    <Link to={`/sellers/view_${seller.id}`}>
                                        {seller.codigo}
                                    </Link>
                                </td>
                                <td>{seller.nombre}</td>
                                <td>{seller.notas}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </Table>
            {loading && <h3 className="text-muted m-3">Cargando...</h3>}
        </>
    )
}